<template>
    <button class="btn" :class="classes" @click="handlerClick">
        <span v-if="icon" class="btn__icon material-icons-outlined">{{ icon }}</span>
        <span v-if="hasDefaultSlot"><slot></slot></span>
    </button>
</template>

<script>
export default {
    name: 'Button',
    props: {
        type: {
            type: String,
            default: 'primary',
            validator: (value) =>
                ['primary', 'secondary', 'outlined', 'icon', 'text', 'large-text', 'navigation'].includes(value),
        },
        icon: String,
        disabled: Boolean,
        fullwidth: Boolean,
        loading: Boolean,
    },
    computed: {
        hasDefaultSlot() {
            return !!this.$slots.default;
        },
        typeClass: function () {
            const obj = {};
            obj['btn-' + this.type] = true;
            return obj;
        },
        classes: function () {
            return {
                'btn-small': this.small,
                'btn-disabled': this.disabled,
                ...this.typeClass,
            };
        },
    },
    methods: {
        handlerClick: function () {
            // убрал, с ним клик два раза отрабатывает
            // if (!this.disabled) this.$emit('click');
        },
    },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

@mixin btn-color($color-default, $color-hover: $color-default, $color-pressed: $color-default) {
    color: $color-default;

    @if $color-hover != $color-default {
        &:hover {
            color: $color-hover;
        }
    }

    @if $color-pressed != $color-default {
        &:active {
            color: $color-pressed;
        }
    }
}

@mixin btn-fill($color-default, $color-hover: $color-default, $color-pressed: $color-default) {
    background-color: $color-default;

    @if $color-hover !=$color-default {
        &:hover {
            background-color: $color-hover;
        }
    }

    @if $color-pressed !=$color-hover {
        &:active {
            background-color: $color-pressed;
        }
    }
}

@mixin btn-border($color-default, $color-hover: $color-default, $color-pressed: $color-default) {
    border-color: $color-default;

    @if $color-hover != $color-default {
        &:hover {
            border-color: $color-hover;
        }
    }

    @if $color-pressed != $color-default {
        &:active {
            border-color: $color-pressed;
        }
    }
}

// styles
.btn {
    align-items: center;
    display: inline-flex;
    justify-content: center;
    flex: 0 0 auto;
    padding: 0 16px;
    font-size: 1rem;
    font-weight: 500;
    line-height: 34px;
    outline: 0;
    position: relative;
    text-decoration: none;
    transition-duration: 0.28s;
    transition-property: box-shadow, transform, opacity, background-color, color;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;
    border: 1px solid transparent;
    border-radius: 4px;
    cursor: pointer;

    span {
        flex: 1;
    }

    &-primary {
        @include btn-color($text-inverted);
        @include btn-fill($primary, $primary-hover, $primary);

        &.btn-disabled {
            @include btn-color($text-inverted);
            @include btn-fill($text-disabled);
        }
    }

    &-secondary {
        @include btn-color($primary, $text-inverted, $text-inverted);
        @include btn-fill($secondary, $secondary-hover, $primary);

        &.btn-disabled {
            @include btn-color($text-inverted);
            @include btn-fill($text-disabled);
        }
    }

    &-outlined {
        @include btn-color($primary, $primary-hover, $primary);
        @include btn-fill(transparent);
        @include btn-border($primary, $primary-hover, $primary);

        &.btn-disabled {
            @include btn-color($text-disabled);
            @include btn-border($text-disabled);
        }
    }

    &-icon {
        @include btn-color($text, $primary-hover, $primary);
        @include btn-fill(transparent, $secondary, $secondary);
        width: 36px;
        height: 36px;
        border-radius: 50%;

        &.btn-disabled {
            @include btn-color($text-disabled);
        }
    }

    &-text {
        @include btn-color($primary, $primary-hover, $primary);
        @include btn-fill(transparent);
        @include btn-border(transparent);
        padding: 0;

        &.btn-disabled {
            @include btn-color($text-disabled);
        }
    }

    &-large-text {
        @include btn-color($text, $primary-hover, $primary);
        @include btn-fill(transparent);
        @include btn-border(transparent);
        padding: 0;

        &.btn-disabled {
            @include btn-color($text-disabled);
        }
    }

    &-navigation {
        @include btn-color($text);
        @include btn-fill(transparent, $secondary, $primary);

        &.btn-disabled {
            @include btn-color($text-disabled);
        }
    }

    &__icon {
        width: auto;
        color: inherit;
        font-size: 18px;

        & + span {
            margin-left: 8px;
        }

        &.material-symbols-outlined {
            font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 48;
        }
    }
}
.btn-disabled {
    cursor: not-allowed;
}
a.btn-icon {
    padding: 0;
}
</style>
